import {css} from '@emotion/css';
import {colours, spacing} from '@fo/shared/styles/variables';

const styles = {
  container: css`
    label: PageErrors__container;
    margin-top: ${spacing.M};
    margin-bottom: ${spacing.XS};
    padding: ${spacing.XXS};
    border: 4px solid ${colours.semantic.ERROR};
  `,
  header: css`
    label: PageErrors__header;
    margin-bottom: 0;
  `,
  list: css`
    label: PageErrors__list;
    margin: 0;
    padding: 0;
    list-style: none;
  `,
  messageButton: css`
    label: PageErrors__messageButton;
    padding: 0;
    color: ${colours.semantic.ERROR};
    font-size: 100%;
    font-family: inherit;
    text-align: left;
    text-decoration: underline;
    background: transparent;
    border: 0;
    outline: none;

    &:hover,
    &:focus {
      color: ${colours.general.WHITE};
      background: ${colours.semantic.ERROR};
    }
  `,
};

export default styles;
